import "./LocationTestAndPanelDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../../shared/services";
import LottieFileGenarationComponent
    from "../../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {ImageConfig} from "../../../../constants";
import StatusCardComponent from "../../../../shared/components/status-card/statusCardComponent";
import LocationTestAndPanelsViewComponent from "./location-test-and-panels-view/LocationTestAndPanelsViewComponent";
import LocationTestAndPanelsEditComponent from "./location-test-and-panels-edit/LocationTestAndPanelsEditComponent";

interface LocationTestAndPanelDetailsViewEditComponentProps {
    locationId: any;
    canEdit: boolean;
    onModeChange: Function;
    locationDetails: any;
}

const LocationTestAndPanelDetailsViewEditComponent = (props: LocationTestAndPanelDetailsViewEditComponentProps) => {

    const {locationId, canEdit,locationDetails} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [isLocationTestAndPanelLoading, setIsLocationTestAndPanelLoading] = useState<boolean>(false);
    const [locationTestAndPanel, setLocationTestAndPanel] = useState<any>(undefined);
    const [isLocationTestAndPanelLoaded, setIsLocationTestAndPanelLoaded] = useState<boolean>(false);
    const [isLocationTestAndPanelLoadingFailed, setIsLocationTestAndPanelLoadingFailed] = useState<boolean>(false);
    const [labTest, setLabTest] = useState<any>(undefined);
    const [labPanel, setLabPanel] = useState<any>(undefined);
    const [isLabTestAndPanelLoading, setIsLabTestAndPanelLoading] = useState<boolean>(false);

    const handleGetLabTestAndPanel = useCallback((labID: string) => {
        const payload = {}
        setIsLabTestAndPanelLoading(true);
        CommonService._lab.getLabTestAndPanels(labID, payload)
            .then((res: any) => {
                setIsLabTestAndPanelLoading(false);
                setLabPanel(res?.data?.panelDetails);
                setLabTest(res?.data?.testDetails);
            })
            .catch((err: any) => {
                setIsLabTestAndPanelLoading(false);
                setLabPanel(undefined);
                setLabTest(undefined);
            })
    }, []);

    useEffect(() => {
        handleGetLabTestAndPanel(locationDetails?.labId);
    }, [locationDetails,handleGetLabTestAndPanel]);

    const handleGetLocationTestAndPanel = useCallback((locationId: string) => {
        const payload = {}
        setIsLocationTestAndPanelLoading(true);
        setIsLocationTestAndPanelLoaded(false);
        setIsLocationTestAndPanelLoadingFailed(false);
        CommonService._location.getLocationTestAndPanels(locationId, payload)
            .then((res: any) => {
                setIsLocationTestAndPanelLoading(false);
                setIsLocationTestAndPanelLoaded(true);
                setIsLocationTestAndPanelLoadingFailed(false);
                setLocationTestAndPanel(res?.data);
            })
            .catch((err: any) => {
                setIsLocationTestAndPanelLoading(false);
                setIsLocationTestAndPanelLoaded(true);
                setIsLocationTestAndPanelLoadingFailed(false);
                setLocationTestAndPanel(undefined);
            })
    }, []);


    useEffect(() => {
        handleGetLocationTestAndPanel(locationId);
    }, [locationId,handleGetLocationTestAndPanel]);

    const handleLocationTestAndPanelEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    const handleLocationAndTestPanelUpdate = useCallback((updatedTestAndPanel: any) => {
        setLocationTestAndPanel(updatedTestAndPanel);
        setMode("view");
    }, []);

    return (
        <div className={'location-test-and-panel-details-view-edit-component  details-tab-data-wrapper'}>
            {
                (isLocationTestAndPanelLoading || isLabTestAndPanelLoading) && <div className="details-screen-loading-icon h-v-center">
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
            {
                isLocationTestAndPanelLoadingFailed && <div className="bg-color-white">
                    <StatusCardComponent title={"Location Attachments failed to load"}/>
                </div>
            }
            {
                isLocationTestAndPanelLoaded &&
                <>
                    {
                        mode === "view" && <LocationTestAndPanelsViewComponent
                            locationTestAndPanel={locationTestAndPanel}
                            canEdit={canEdit}
                            onEditModeOpen={(testAndPanel: any) => {
                                setLocationTestAndPanel(testAndPanel)
                                setMode("edit")
                            }}
                        />
                    }
                    {
                        mode === "edit" && <LocationTestAndPanelsEditComponent
                            onEditCancel={() => {
                                handleLocationTestAndPanelEditCancel()
                            }}
                            locationId={locationId}
                            labTest={labTest}
                            labPanel={labPanel}
                            locationTestAndPanel={locationTestAndPanel}
                            canEdit={canEdit}
                            onUpdateComplete={handleLocationAndTestPanelUpdate}
                        />
                    }
                </>
            }
        </div>
    );

};

export default LocationTestAndPanelDetailsViewEditComponent;